import { render, staticRenderFns } from "./ODVExtension.vue?vue&type=template&id=a08ebfcc"
import script from "./ODVExtension.vue?vue&type=script&lang=js"
export * from "./ODVExtension.vue?vue&type=script&lang=js"
import style0 from "./ODVExtension.vue?vue&type=style&index=0&id=a08ebfcc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports